import React from 'react';
import { useNavigate } from 'react-router-dom';
import {Button, theme} from "antd";

const NotFound = () => {
    const navigate = useNavigate();
    const { token } = theme.useToken();

    const handleHomeClick = () => {
        try {
            navigate('/layout');
        } catch (error) {
            console.log(error)
            navigate('/');
        }
    };

    return (
        <div className="not-found-container">
            <div className="not-found-content">
                <h1 className="error-code" style={{color: token.colorPrimary}}>404</h1>
                <p className="error-message">Страница не найдена</p>
                <p className="error-description">
                    Извините, запрашиваемая страница не существует или была перемещена.
                </p>
                <Button type="primary" size="large" style={{width: "100%"}}
                    onClick={handleHomeClick}>
                    Вернуться на главную
                </Button>
            </div>

            <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .not-found-container {
          min-height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #f8fafc;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
          padding: 20px;
        }

        .not-found-content {
          text-align: center;
          max-width: 500px;
          width: 100%;
          padding: 40px 30px;
          background-color: #ffffff;
          border-radius: 16px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
        }

        .error-code {
          font-size: 120px;
          font-weight: 700;
          line-height: 1;
          margin-bottom: 16px;
          letter-spacing: -4px;
        }

        .error-message {
          font-size: 24px;
          font-weight: 500;
          color: #1a1a2e;
          margin-bottom: 12px;
        }

        .error-description {
          font-size: 15px;
          color: #64748b;
          line-height: 1.6;
          margin-bottom: 32px;
        }

        /* Адаптив для мобильных */
        @media (max-width: 480px) {
          .error-code {
            font-size: 80px;
          }

          .error-message {
            font-size: 20px;
          }

          .not-found-content {
            padding: 32px 20px;
          }
          
        }
      `}</style>
        </div>
    );
};

export default NotFound;